import { Component, inject, OnInit, HostListener } from '@angular/core';
import { DatePickerModule } from 'primeng/datepicker';
import { Select } from 'primeng/select';
import {
  FormBuilder,
  ReactiveFormsModule,
  FormGroup,
  Validators,
} from '@angular/forms';
import { TagModule } from 'primeng/tag';
import { CardCampanhaDashComponent } from '@app/shared/components/card-campanha-dash/card-campanha-dash.component'; 
import { CommonModule } from '@angular/common';
import { MenuItem, MessageService, ConfirmationService } from 'primeng/api';
import { EnumService } from '@app/shared/components/api/services/enum.service';
import { CategoriaService } from '@app/shared/components/api/services/categoria.service';
import { CampanhaService } from '@app/shared/components/api/services/campanha.service';
import { forkJoin } from 'rxjs';
import { Pagination } from '@app/shared/components/api/models/pagination.model';
import { PaginatorControlComponent } from '@app/shared/components/paginator-control/paginator-control.component';
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import { UserService } from '@app/auth/services/user.service';
import { Router, RouterModule } from '@angular/router';
import { SkeletonLoaderComponent } from '@app/shared/components/skeleton-loader/skeleton-loader.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { EstadoCampanhaENUM } from '@app/shared/components/api/models/estadoCampanha.enum';
import { Skeleton } from 'primeng/skeleton';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { Drawer } from 'primeng/drawer';
import { AdminDetalheCampanhaComponent } from '@app/features-modules/admin/components/campanhas/components/admin-detalhe-campanha/admin-detalhe-campanha.component';
import { Textarea } from 'primeng/textarea';
import { Menu } from 'primeng/menu';

@Component({
  selector: 'app-dashboard-campanha',
  imports: [
    DatePickerModule,
    Select,
    ReactiveFormsModule,
    TagModule,
    CardCampanhaDashComponent,
    CommonModule,
    PaginatorControlComponent,
    DataVoidComponent,
    SkeletonLoaderComponent,
    ConfirmDialogModule,
    Skeleton,
    DialogModule,
    ButtonModule,
    Drawer,
    AdminDetalheCampanhaComponent,
    Textarea,
    RouterModule,
  ],
  standalone: true,
  providers: [CategoriaService, EnumService, CampanhaService, UserService],
  templateUrl: './dashboard-campanha.component.html',
  styleUrl: './dashboard-campanha.component.scss',
})
export class DashboardCampanhaComponent implements OnInit {
  //injections
  private readonly fb = inject(FormBuilder);
  private readonly route = inject(Router);
  private readonly categoriaService = inject(CategoriaService);
  private readonly enumService = inject(EnumService);
  private readonly campanhaService = inject(CampanhaService);
  private readonly userService = inject(UserService);
  private readonly messageService = inject(MessageService);
  private readonly confirmationService = inject(ConfirmationService);

  // variables control
  formFilters!: FormGroup;
  formExtendDate!: FormGroup;
  categoriaList: any[] = [];
  estadoList: any[] = [];
  indicadores: Record<string, number> = {};
  pagination: Pagination<any> = new Pagination<any>();
  UserID: any;
  ShowBtnewCampanha: boolean = false;
  loading: boolean = false;
  loadIndicators: boolean = false;
  showDialogExtend: boolean = false;
  visible: boolean = false;
  campanhaSelecionada: any;

  diasList = [
    { name: '7', key: '7' },
    { name: '15', key: '15' },
    { name: '30', key: '30' },
    { name: '45', key: '45' },
    { name: '60', key: '60' },
    { name: '75', key: '75' },
    { name: '90', key: '90' },
  ];

  ngOnInit(): void {
    this.UserID = this.userService.getUserId();
    this.initForms();
    this.loadDropdowns();
    this.getAllCampanhas();
    this.getIndicators();

    //capturar qualquer alteração nos filtros e fazer a requisição novamente
    this.formFilters.valueChanges.subscribe(() => {
      this.getAllCampanhas();
    });
  }

  initForms() {
    this.formFilters = this.fb.group({
      DataInicio: [null],
      CategoriaId: [null],
      EstadoCampanhaENUM: [null],
    });

    this.formExtendDate = this.fb.group({
      dataAntiga: [{ value: '', disabled: true }],
      dias: [null, Validators.required],
      motivo: [null, Validators.required],
    });
  }

  // get action menu by status
  getActionsByEstado(campanha: any): MenuItem[] {
    const baseActions: MenuItem[] = [
      {
        label: 'Ver detalhes',
        icon: 'pi pi-eye',
        command: () => this.verDetalhe(campanha),
      },
    ];

    switch (campanha.estadoCampanhaENUM) {
      case EstadoCampanhaENUM.Rascunho:
        return [
          ...baseActions,
          {
            label: 'Excluir rascunho',
            icon: 'pi pi-trash',
            command: () => this.excluirCampanha(campanha),
          },
          {
            label: 'Editar rascunho',
            icon: 'pi pi-pencil',
            command: () => this.editarRascunho(campanha),
          },
        ];

      case EstadoCampanhaENUM.Publicado:
      case EstadoCampanhaENUM.EmCurso:
        return [
          ...baseActions,
          {
            label: 'Solicitar prorrogação',
            icon: 'pi pi-pencil',
            command: () => this.openExtendDialog(campanha),
          },
          // {
          //   label: 'Suspender campanha',
          //   icon: 'pi pi-pause',
          //   command: () => this.suspenderCampanha(campanha),
          // },
          // {
          //   label: 'Encerrar campanha',
          //   icon: 'pi pi-lock',
          //   command: () => this.encerrarCampanha(campanha),
          // },
        ];

      case EstadoCampanhaENUM.Suspensa:
        return [
          ...baseActions,
          // {
          //   label: 'Retomar campanha',
          //   icon: 'pi pi-play',
          //   command: () => this.retomarCamapnha(campanha),
          // },
        ];

      case EstadoCampanhaENUM.Encerrada:
        return [...baseActions];

      default:
        return baseActions;
    }
  }

  // Publicar campanha -- Estado 3
  retomarCamapnha(campanha: any) {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja retomar com esta campanha?',
      header: 'Confirmação',
      closable: true,
      closeOnEscape: true,
      icon: 'pi pi-exclamation-triangle',
      rejectButtonProps: {
        label: 'Cancelar',
        severity: 'secondary',
        outlined: true,
      },
      acceptButtonProps: {
        label: 'Sim, Retomar',
      },
      accept: () => {
        const id = campanha?.id;
        const estado = '4';

        this.campanhaService.updateStatus(id, estado).subscribe({
          next: (res) => {
            this.messageService.add({
              severity: 'success',
              summary: 'Sucesso',
              detail: 'Campanha retomada com sucesso!',
              life: 5000,
            });
            this.getAllCampanhas();
          },
          error: (err) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Erro',
              detail: 'Ocorreu um erro ao retomar a campanha',
              life: 5000,
            });
            console.error(err);
          },
        });
      },
      reject: () => {
        // Ação ao cancelar (se necessário
      },
    });
  }

  // Supender campanha -- Estado 5
  suspenderCampanha(campanha: any) {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja suspender esta campanha?',
      header: 'Confirmação',
      closable: true,
      closeOnEscape: true,
      icon: 'pi pi-exclamation-triangle',
      rejectButtonProps: {
        label: 'Cancelar',
        severity: 'secondary',
        outlined: true,
      },
      acceptButtonProps: {
        label: 'Sim, suspender',
      },
      accept: () => {
        const id = campanha?.id;
        const estado = '5';

        this.campanhaService.updateStatus(id, estado).subscribe({
          next: (res) => {
            this.messageService.add({
              severity: 'success',
              summary: 'Sucesso',
              detail: 'Campanha suspensa com sucesso!',
              life: 5000,
            });
            this.getAllCampanhas();
          },
          error: (err) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Erro',
              detail: 'Ocorreu um erro ao suspender a campanha',
              life: 5000,
            });
            console.error(err);
          },
        });
      },
      reject: () => {
        // Ação ao cancelar (se necessário
      },
    });
  }

  // Supender campanha -- Estado 6
  encerrarCampanha(campanha: any) {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja encerrar esta campanha?',
      header: 'Confirmação',
      closable: true,
      closeOnEscape: true,
      icon: 'pi pi-exclamation-triangle',
      rejectButtonProps: {
        label: 'Cancelar',
        severity: 'secondary',
        outlined: true,
      },
      acceptButtonProps: {
        label: 'Sim, Encerrar',
      },
      accept: () => {
        const id = campanha?.id;
        const estado = '6';

        this.campanhaService.updateStatus(id, estado).subscribe({
          next: (res) => {
            this.messageService.add({
              severity: 'success',
              summary: 'Sucesso',
              detail: 'Campanha encerrada com sucesso!',
              life: 5000,
            });
            this.getAllCampanhas();
          },
          error: (err) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Erro',
              detail: 'Ocorreu um erro ao encerrar a campanha',
              life: 5000,
            });
            console.error(err);
          },
        });
      },
      reject: () => {
        // Ação ao cancelar (se necessário
      },
    });
  }

  // Excluir campanha -- Permanente
  excluirCampanha(campanha: any) {
    this.confirmationService.confirm({
      message:
        'Tem certeza que deseja eliminar esta campanha?. Esta ação é irreversível?',
      header: 'Confirmação',
      closable: true,
      closeOnEscape: true,
      icon: 'pi pi-exclamation-triangle',
      rejectButtonProps: {
        label: 'Cancelar',
        severity: 'secondary',
        outlined: true,
      },
      acceptButtonProps: {
        label: 'Sim, Eliminar',
      },
      accept: () => {
        const id = campanha?.id;

        this.campanhaService.delete(id).subscribe({
          next: (res) => {
            this.messageService.add({
              severity: 'success',
              summary: 'Sucesso',
              detail: 'Campanha eliminada com sucesso!',
              life: 5000,
            });
            this.getAllCampanhas();
          },
          error: (err) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Erro',
              detail: 'Ocorreu um erro ao eliminar a campanha',
              life: 5000,
            });
            console.error(err);
          },
        });
      },
      reject: () => {
        // Ação ao cancelar (se necessário
      },
    });
  }

  // Dropdowns
  loadDropdowns() {
    forkJoin({
      // Enums
      estadoCampanha: this.enumService.getAllEstadoCampanha(),

      // Listas
      categoria: this.categoriaService.listPublic({ pageSize: 100 }),
    }).subscribe((response) => {
      // Enums
      if (response.estadoCampanha?.data) {
        this.estadoList = Object.entries(response.estadoCampanha.data).map(
          ([key, value]) => ({
            id: Number(key),
            label: value as string,
          }),
        );
      }
      // Listas
      if (response.categoria?.data) {
        this.categoriaList = response.categoria.data.map((item: any) => ({
          id: item.id,
          label: item.descricao,
        }));
      }
    });
  }

  getAllCampanhas() {
    this.loading = true;
    const filters = { ...this.formFilters.value };
    Object.keys(filters).forEach((key) => {
      if (filters[key] === null) {
        delete filters[key];
      }
    });

    const params = {
      PageSize: this.pagination.pageSize || 5,
      PageNumber: this.pagination.pageNumber || 1,
      OrderBy: 'id desc',
      UtilizadorID: this.UserID,
      ...filters,
    };

    this.campanhaService.listPublic(params).subscribe({
      next: (res) => {
        if (!res.data || res.data.length < 1) {
          this.messageService.add({
            severity: 'warn',
            summary: 'Usuário sem campanhas',
            detail: 'Ainda não criaste nenhuma campanha.',
            life: 5000,
          });
        }

        this.pagination = new Pagination<any>().deserialize(res);
        this.loading = false;
      },
      error: (err) => {
        console.error(err);
        this.loading = false;
      },
    });
  }

  getIndicators() {
    this.loadIndicators = true;
    const filters = { ...this.formFilters.value };
    Object.keys(filters).forEach((key) => {
      if (filters[key] === null) {
        delete filters[key];
      }
    });

    const params = {
      PageSize: 1000000,
      PageNumber: this.pagination.pageNumber || 1,
      OrderBy: 'id desc',
      UtilizadorID: this.UserID,
      ...filters,
    };

    this.campanhaService.listPublic(params).subscribe({
      next: (res) => {
        if (!res.data || res.data.length < 1) {
          this.ShowBtnewCampanha = true;
          this.loadIndicators = false;
          return;
        }
        const campanhas = res?.data;
        // Mapeamento dos estados
        const indicadores: Record<string, number> = {};

        campanhas?.forEach((c: { estadoCampanha: string }) => {
          const estado = c.estadoCampanha || 'Desconhecido';
          indicadores[estado] = (indicadores[estado] || 0) + 1;
        });

        // indicadores
        this.indicadores = {
          ...indicadores,
        };
        this.loadIndicators = false;
      },
      error: (err) => {
        console.error(err);
        this.loadIndicators = false;
      },
    });
  }

  onPageChange(event: any) {
    this.pagination.pageNumber = event.page + 1;
    this.pagination.pageSize = event.rows;
    this.getAllCampanhas();
  }

  callRouteCreateCamapnha() {
    this.route.navigate(['/criar-campanha']);
  }

  openExtendDialog(campanha: any) {
    this.campanhaSelecionada = campanha;
    this.showDialogExtend = true;
    this.formExtendDate.patchValue({
      dataAntiga: this.campanhaSelecionada?.dataTerminoFormatada,
    });
  }

  // Extender data de término da campanha
  extendCampanha() {
    this.loading = true;

    const params = {
      campanhaID: this.campanhaSelecionada?.id,
      motivo: this.formExtendDate.get('motivo')?.value,
      dias: Number(this.formExtendDate.get('dias')?.value),
    };

    this.campanhaService.extend(params).subscribe({
      next: (res) => {
        if (res.retorno.codigo === 200) {
          this.messageService.add({
            severity: 'success',
            summary: 'Sucesso',
            detail:
              'A sua solicitação de prorrogação foi feita. Aguarde a aprovação!',
            life: 5000,
          });
          this.getAllCampanhas();
          this.showDialogExtend = false;
          this.loading = false;
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail:
              `${res.retorno.mensagem}` ||
              ` Ocorreu um erro ao solicitar a prorrogação da data de término da campanha`,
            life: 5000,
          });
          this.loading = false;
          this.close();
        }
      },
      error: (err) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail:
            'Ocorreu um erro ao prorrogação da data de término da campanha',
          life: 5000,
        });
        console.error(err);
        this.loading = false;
        this.close();
      },
    });
  }

  // Editar campanha (Estado rascunho)
  editarRascunho(campanhaOrId: any) {
    const id =
      campanhaOrId && typeof campanhaOrId === 'object'
        ? campanhaOrId.id
        : campanhaOrId;

    if (!id) return;

    this.route.navigate(['/editar-rascunho/', id]);
  }

  verDetalhe(campanha: any) {
    this.campanhaSelecionada = campanha;
    this.visible = true;
  }

  close() {
    this.showDialogExtend = false;
    this.formExtendDate.reset();
  }

  // controle de menus
  openedMenu: Menu | null = null;

  setOpenedMenu(menu: Menu) {
    if (this.openedMenu && this.openedMenu !== menu) {
      this.openedMenu.hide();
    }
    this.openedMenu = menu;
  }

  clearOpenedMenu() {
    this.openedMenu = null;
  }

  @HostListener('document:click')
  onDocumentClick() {
    if (this.openedMenu) {
      this.openedMenu.hide();
      this.openedMenu = null;
    }
  }
}
